// extracted by mini-css-extract-plugin
export default {"mCard":"tC-z","image":"uC-z","imageNoBackground":"vC-z","fullWidth":"wC-z"};